import useDashboardGraphDates from 'containers/dashboard/hooks/useDashboardGraphDates';
import { DashboardTimeFrame } from 'containers/dashboard/types/types';
import { useWeeklyPopulator } from 'hooks';
import useActivityReportNavigation from 'hooks/navigation/useActivityReportNavigation';
import { isNull, last } from 'lodash';
import { DateTime } from 'luxon';
import TimeRangeType from 'types/TimeRangeType';
import { useFeatureFlags } from 'utils/features';

export default function useActiveCardReportNavigation(
  timeFrame: DashboardTimeFrame,
  filterType: 'by-project' | 'by-employee' | 'by-cost-code' | 'by-equipment'
) {
  const { timeRange, timeRanges } = useDashboardGraphDates(timeFrame)!; // Null force safe for all settings but `clockStatus`

  const isPro = useFeatureFlags('PRO');
  const currentTime = DateTime.utc().startOf('day');
  const weeklyRangeGet = useWeeklyPopulator();

  const activityReportNavigation = useActivityReportNavigation();

  function openActivityReport() {
    let timeRangeType = TimeRangeType.CUSTOM;
    switch (timeFrame) {
      case 'payPeriod':
        timeRangeType = TimeRangeType.PAY_PERIOD;
        break;
      case 'monthly':
        timeRangeType = TimeRangeType.MONTHLY;
        break;
      case 'weekly':
        timeRangeType = TimeRangeType.WEEKLY;
        break;
      default:
        timeRangeType = TimeRangeType.CUSTOM;
        break;
    }
    let navRange = timeRange;
    if (timeFrame !== 'pastSeven' && timeFrame !== 'pastFourteen') {
      const lastRange = last(timeRanges);
      if (lastRange) {
        navRange = {
          startTime: DateTime.fromSeconds(lastRange.startTime, { zone: 'utc' }),
          endTime: DateTime.fromSeconds(lastRange.endTime, { zone: 'utc' }),
        };
      }
    }
    if (isPro) {
      activityReportNavigation({
        filter_type: filterType,
        time_range_type: timeRangeType,
        start_date: navRange.startTime.toISODate(),
        end_date: navRange.endTime.toISODate(),
      });
    } else {
      const weeklyRange = last(weeklyRangeGet(1, currentTime.toSeconds())) ?? null;
      if (!isNull(weeklyRange)) {
        activityReportNavigation({
          filter_type: filterType,
          time_range_type: TimeRangeType.WEEKLY,
          start_date: weeklyRange.startTime.toISODate(),
          end_date: weeklyRange.endTime.toISODate(),
        });
      }
    }
  }

  return openActivityReport;
}
